export default {
  "content": "<g clip-path=\"url(#a)\"><path fill=\"#3F4450\" d=\"M13.433 14.667H5.07a1.68 1.68 0 01-1.202-.51l-.87-.89a1.173 1.173 0 01-.332-.82V1.913c0-.32.254-.58.567-.58h8.5c.313 0 .566.26.566.58v10.435c0 .32-.253.58-.566.58H4.602a.142.142 0 00-.131.089.147.147 0 00.03.158l.16.162a.56.56 0 00.4.17h7.663a.143.143 0 00.142-.145V3.217c0-.08.063-.145.142-.145h.425c.313 0 .566.26.566.58v10.435c0 .32-.253.58-.566.58z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none"
  }
};